function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgCommunity(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2.852A4.193 4.193 0 003.012 5.04 4.193 4.193 0 007.2 9.228c2.31 0 4.188-1.879 4.188-4.188A4.193 4.193 0 007.2.852zm0 9.228a5.046 5.046 0 01-5.04-5.04C2.16 2.26 4.42 0 7.2 0c2.78 0 5.04 2.261 5.04 5.04s-2.26 5.04-5.04 5.04zM14.4 19.08h-.847v-2.798c0-1.96-1.26-3.555-2.81-3.555H3.657c-1.549 0-2.809 1.595-2.809 3.555v2.798H0v-2.798c0-2.427 1.64-4.402 3.656-4.402h7.088c2.016 0 3.656 1.975 3.656 4.402v2.798zM17.32 2.511a2.516 2.516 0 00-2.513 2.513 2.516 2.516 0 002.513 2.513 2.516 2.516 0 002.513-2.513A2.516 2.516 0 0017.32 2.51zm0 5.537a3.027 3.027 0 01-3.024-3.024A3.027 3.027 0 0117.32 2a3.027 3.027 0 013.024 3.024 3.027 3.027 0 01-3.024 3.024z",
    fill: props.color
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M17.32 2.311a2.716 2.716 0 00-2.713 2.713h.4A2.316 2.316 0 0117.32 2.71v-.4zm-2.713 2.713a2.716 2.716 0 002.713 2.713v-.4a2.316 2.316 0 01-2.313-2.313h-.4zm2.713 2.713a2.716 2.716 0 002.713-2.713h-.4a2.316 2.316 0 01-2.313 2.313v.4zm2.713-2.713A2.716 2.716 0 0017.32 2.31v.4a2.316 2.316 0 012.313 2.313h.4zM17.32 7.848a2.828 2.828 0 01-2.824-2.824h-.4a3.227 3.227 0 003.224 3.224v-.4zm-2.824-2.824A2.827 2.827 0 0117.32 2.2v-.4a3.227 3.227 0 00-3.224 3.224h.4zM17.32 2.2a2.827 2.827 0 012.824 2.824h.4A3.227 3.227 0 0017.32 1.8v.4zm2.824 2.824a2.827 2.827 0 01-2.824 2.824v.4a3.227 3.227 0 003.224-3.224h-.4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.64 13.448h-.508v-1.679c0-1.176-.757-2.133-1.686-2.133h-4.253c-.929 0-1.685.957-1.685 2.133v1.679H13v-1.679c0-1.456.984-2.641 2.194-2.641h4.252c1.21 0 2.194 1.185 2.194 2.641v1.679z",
    fill: props.color,
    stroke: props.color,
    strokeWidth: 0.4
  }));
}

export default SvgCommunity;